import React, { useState, useEffect } from 'react';
import HorizontalTabs from '../components/HorizontalTabs';
import { Link } from 'react-router-dom';
import data from '../data.json';
import { LazyLoadImage } from 'react-lazy-load-image-component';



function Events() 
{

  // 👉 R2 se auto load karne ke liye
  const [dynamicEvents, setDynamicEvents] = useState([]);

  useEffect(() => {
    fetch('/data_events.json')
      .then((res) => (res.ok ? res.json() : []))
      .then((json) => {
        if (Array.isArray(json)) setDynamicEvents(json);
      })
      .catch((err) => console.log('No dynamic events:', err));
  }, []);

  const dynamicTabs = dynamicEvents.map((ev) => ({
    title: ev.title,
    heroImg: ev.images?.[0] || 'newimg/P11.webp',
    content: () => (
      <div>
        <div className="cam-lower-sec">
          <h1 className="title">{ev.title}</h1>
        </div>
        <div className="photo-sec">
          {ev.images && ev.images.map((imgUrl, idx) => (
            <div key={idx} className="photo-box">
              <Link to={imgUrl} target="_blank" rel="noopener noreferrer">
                <LazyLoadImage src={imgUrl} alt={ev.title} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    ),
  }));
  const staticTabs = [

    {
      title: 'Kanni Thahryamal Trophy ', 
      heroImg: 'newimg/P11.webp',
      content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Kanni Thahryamal Trophy</h1>
        </div>
        <div className="photo-sec">
          {data.Events.KanniThahryamalTrophy.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>

      </div>

    },

     {
      title: 'French Exhibition ', 
      heroImg: 'newimg/P11.webp',
      content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>French Exhibition</h1>
        </div>
        <div className="photo-sec">
          {data.Events.FrenchRxhibition.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>

      </div>

    },

    {
      title: 'World Art day ', 
      heroImg: 'newimg/P11.webp',
      content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>World Art day</h1>
        </div>
        <div className="photo-sec">
          {data.Events.WorldCreativityDay.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>

      </div>

    },
    {
      title: 'Sports Day', 
      heroImg: '../img/Events/Fire Less Cooking/cooking04.webp',
      content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Sports Day</h1>
        </div>
        <div className="photo-sec">
          {data.Events.SportsDay.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>

      </div>

    },
    {
      title: 'MUN', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>MUN</h1>
        </div>
        <div className="photo-sec">
                  {data.Events.MUN.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
              </div>

      </div>

    },
    {
      title: 'Science Park Visit', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Science Park Visit</h1>
        </div>
        <div className="photo-sec">
          {data.Events.ScienceParkVisit.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>

      </div>

    },
    {
      title: 'Meditation Day', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Meditation Day</h1>
        </div>
        <div className="photo-sec">
          {data.Events.MeditationDay.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>

      </div>

    },
    {
      title: 'Investiture Ceremony', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Investiture Ceremony</h1>
        </div>
        <div className="photo-sec">
          {data.Events.InvestitureCeremony.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}
        </div>
      </div>
    },
    {
      title: 'IIHM Young Chef Juniors & Teachers', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>IIHM Young Chef Juniors & Teachers</h1>
        </div>
        <div className="photo-sec">
          {data.Events.IIHMfood.map((person) => (

            <div key={person.id} className="photo-box">
              <Link 
                to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                target="_blank"
                rel="noopener noreferrer"
                >
                <LazyLoadImage
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                  alt={person.alt} 
                   />
                </Link>
              </div>
          ))}
        </div>
      </div>
    },
    {
      title: 'Assam Donate Drive', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Assam Donate Drive</h1>
        </div>
        <div className="photo-sec">
          {data.Events.AssamDonate.map((person) => (

            <div key={person.id} className="photo-box">
              <Link 
                to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                target="_blank"
                rel="noopener noreferrer"
                >
                <LazyLoadImage
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                  alt={person.alt} 
                   />
                </Link>
              </div>
          ))}
        </div>
      </div>
    },
    {
      title: 'No Bag Day Activity', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>No Bag Day Activity</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.NoBagDay.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },
    {
      title: 'Fire Less Cooking', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Fire Less Cooking</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking16.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Fire Less Cooking/cooking18.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Fire Less Cooking/cooking18.webp'></img>
            </Link>
          </div>
         


          
          </div>
        </div>
    },

     {
      title: 'Art Day Activity', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Art Day Activity</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Art Day/2025/art-25-16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Art Day/2025/art-25-16.webp'></img>
            </Link>
          </div>
        </div>
        </div>
        
        },



    {
      title: 'Sanskar Talk', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Sanskar Talk</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.SanskarTalk.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },
    {
      title: 'Halloween', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Halloween</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.Halloween.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },
    {
      title: 'University Fair', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>University Fair</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.nunif2026.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
        <br/>
           <div className='cam-lower-sec'>
          <h1 className='title'>Global University Fair</h1>
        </div>
         <div className='photo-sec'>

          {data.Events.globalf2026.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>

      </div>
    },
    {
      title: 'Visual Arts', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Visual Arts</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.VisualArts.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },
    {
      title: "Grandparent's day", content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Grandparent's day</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.Grandparent.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },


    {
      title: 'Diwali Card Making', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Diwali Card Making</h1>
        </div>

        <div className='photo-sec'>
          {/* {data.Events.NoBagDay.map((person) => (
            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))} */}
          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-1.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-1.webp'></img>
            </Link>
          </div>


          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-2.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-2.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-3.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-3.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-4.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-5.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-5.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-6.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-7.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-7.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-8.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-8.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-9.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-9.webp'></img>
            </Link>
          </div>


          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-10.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Card Making 2024/Card Making-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Card Making 2024/Card Making-11.webp'></img>
            </Link>
          </div>



        </div>
      </div>
    },
   { title: 'International Labour Day', content: () => <div>
   
           <div className='cam-lower-sec'>
              <h1 className='title'>CAS Activity: International Labour Day</h1>
           </div>
       
           <div className='photo-sec'>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img01.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img01.webp'></img>
               </Link>
             </div>
           
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img02.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img02.webp'></img>
               </Link>
             </div>
             
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img03.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img03.webp'></img>
               </Link>
             </div>
            
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img04.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img04.webp'></img>
               </Link>
             </div>
            
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img005.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img005.webp'></img>
               </Link>
             </div>
             
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img05.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img05.webp'></img>
               </Link>
             </div>
             
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img06.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img06.webp'></img>
               </Link>
             </div>
            
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img07.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img07.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img08.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img08.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img09.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img09.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img10.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img10.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img11.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img11.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img12.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img12.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img13.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img13.webp'></img>
               </Link>
             </div>
             <div className='photo-box'>
             <Link to="../img/Cas/Labour Day/2026/img14.webp"
                 target="_blank"
                 rel="noopener noreferrer">
                <img src='../img/Cas/Labour Day/2026/img14.webp'></img>
               </Link>
             </div>
           
           </div>
           </div>
           },
    {
      title: 'Mosaic', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>MOSAIC - Inter School Art Competition 2026</h1>
        </div>
        {/* <div className='cam-lower-sec'>
          <h1 className='title'>MOSAIC - Inter School Art Competition 2025</h1>
        </div> */}

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-01.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-02.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-03.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-04.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-05.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-06.webp'></img>
            </Link>
          </div>

         

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-08.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-09.webp'></img>
            </Link>
          </div>
        
          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-10.webp'></img>
            </Link>
          </div>
        
          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-11.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-12.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-13.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-14.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-15.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-16.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-17.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-17.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-18.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-18.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/mosaic/2026/mosaic-19.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/mosaic/2026/mosaic-19.webp'></img>
            </Link>
          </div>

      
      
      
      
      
      




        </div>
    
      </div>
    },
    {
      title: 'Best Out of Waste Activity', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Best Out of Waste Activity</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img01.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img01.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img02.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img02.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img03.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img03.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img04.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img04.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img05.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img05.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img06.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img06.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img07.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img07.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img08.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img08.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img09.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img09.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img10.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img10.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img11.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img11.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img12.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img12.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img13.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img13.jpeg'></img>
            </Link>
          </div>
        
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img15.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img15.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img16.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img16.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img17.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img17.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img18.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img18.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img19.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img19.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img20.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img20.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img21.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img21.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img22.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img22.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img23.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img23.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img24.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img24.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img25.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img25.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img26.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img26.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img27.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img27.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img28.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img28.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img29.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img29.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img30.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img30.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Best Out of Waste/img31.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Best Out of Waste/img31.jpeg'></img>
            </Link>
          </div>


          </div>
          </div>
          },
    {
      title: 'Paper Bag Day Activity', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Paper Bag Day Activity</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img01.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img01.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img02.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img02.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img03.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img03.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img04.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img04.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img05.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img05.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img06.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img06.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img07.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img07.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img08.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img08.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img09.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img09.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Paper Bag/img10.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Paper Bag/img10.jpeg'></img>
            </Link>
          </div>
          </div>
          </div>
          },

            {
      title: 'Pre-Primary Meditation Day', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Pre-Primary Meditation Day</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-01.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-01.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-02.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-02.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-03.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-03.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-04.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-04.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-05.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-05.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-06.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-06.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-07.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-07.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-08.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-08.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-09.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-09.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-10.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-10.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-11.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-11.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-12.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-12.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-13.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-13.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-14.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-14.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Pre Meditation Day/img-15.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Pre Meditation Day/img-15.jpeg'></img>
            </Link>
          </div>

          </div>
          </div>
          },
          
     
    {
      title: 'ATAL Community Day', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>ATAL Community Day 2025</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2025/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2025/img08.webp'></img>
            </Link>
          </div>
         


        </div>


        {/* <div className='cam-lower-sec'>
         <h1 className='title'>ATAL Community Day 2024</h1>
      </div> */}

        {/* <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-1.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-1.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-2.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-2.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-3.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-3.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-4.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-5.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-5.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-6.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-7.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-7.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-8.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-8.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-9.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-9.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-13.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/ATAL Community Day 2024/ATL-16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/ATAL Community Day 2024/ATL-16.webp'></img>
            </Link>
          </div>




        </div> */}
      </div>
    },
    {
      title: 'Session Begins on a fresh note', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>A Fresh Chapter Unfolds as Session 2025-26 Begins at Sanskar.</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/session2025/img14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/session2025/img14.webp'></img>
            </Link>
          </div>










        </div>


        {/* <div className='cam-lower-sec'>
         <h1 className='title'>Sanskar School Session 2024-25 begins on a fresh note</h1>
      </div> */}

        {/* <div className='photo-sec'>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-1.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-1.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-2.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-2.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-3.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-3.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-4.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-4.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-5.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-5.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-6.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-6.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-7.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-7.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-8.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-8.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-9.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-9.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-10.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-10.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-11.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-11.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-12.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-12.webp'></img>
          </Link>
        </div>
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-13.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-13.webp'></img>
          </Link>
        </div>

        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-15.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-15.webp'></img>
          </Link>
        </div>
     
        <div className='photo-box'>
        <Link to="../img/Events/Session 24-25/FD-16.webp"
            target="_blank"
            rel="noopener noreferrer">
           <img src='../img/Events/Session 24-25/FD-16.webp'></img>
          </Link>
        </div>
     
       


        </div> */}
      </div>
    },
    {
      title: "Graduation Ceremony", content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Graduation Ceremony 2026</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.GraduationCeremony.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },

    {
      title: 'Graduation Ceremony', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Graduation Ceremony 2025</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2025/img-14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2025/img-14.webp'></img>
            </Link>
          </div>
        </div>
        <br />
        <br />
        <div className='cam-lower-sec'>
          <h1 className='title'>Graduation Ceremony 2024</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-1.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-1.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-2.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-2.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-3.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-3.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-4.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-5.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-5.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-6.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-7.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-7.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-8.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-8.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-9.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-9.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-10.webp'></img>
            </Link>
          </div>


          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-12.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-13.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-14.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-15.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-16.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-17.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-17.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-18.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-18.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-19.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-19.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-20.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Graduation Ceremony/2024/Graduation Ceremony 2024-20.webp'></img>
            </Link>
          </div>






        </div>
      </div>
    },

{
      title: 'Fiesta', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Fiesta 2026</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.Fiesta2026.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
        <br/>

      </div>
    },
{
      title: 'Poster Making', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Poster Making</h1>
        </div>

        <div className='photo-sec'>

          {data.Events.PosterMaking.map((person) => (

            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>

          ))}

        </div>
      </div>
    },


    {
      title: 'Christmas Day Celebration', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Christmas Day Celebration</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-1.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-1.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-2.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-2.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-3.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-3.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-4.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-5.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-5.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-6.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-7.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-7.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-8.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-8.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-9.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-9.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Christmas/Christmas Day-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Christmas/Christmas Day-12.webp'></img>
            </Link>
          </div>





        </div>
      </div>
    },
    {
      title:'Pre-Primary Gardening Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Pre-Primary Gardening Day</h1>
        </div>
        <div className='photo-sec'>
        <div className='photo-box'>
            <Link to="../img/Events/Gardening day/img-01.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Gardening day/img-01.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Gardening day/img-02.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Gardening day/img-02.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Gardening day/img-03.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Gardening day/img-03.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Gardening day/img-04.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Gardening day/img-04.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Gardening day/img-05.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Gardening day/img-05.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Gardening day/img-06.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Gardening day/img-06.jpeg'></img>
            </Link>
            </div>

        </div>

      </div>
    },
    {
      title:'Rakhi Making', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Rakhi Making</h1>
        </div>
        <div className='photo-sec'>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-01.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-01.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-02.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-02.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-03.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-03.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-04.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-04.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-05.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-05.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-06.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-06.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-07.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-07.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-08.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-08.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-09.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-09.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-10.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-10.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-11.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-11.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-12.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-12.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-13.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-13.jpeg'></img>
            </Link>
            </div>
        <div className='photo-box'>
            <Link to="../img/Events/Rakhi Making/img-14.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Rakhi Making/img-14.jpeg'></img>
            </Link>
            </div>


        </div>

      </div>
    },
    {
      title: 'Color Day', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Color Day</h1>
        </div>

        <div className="photo-sec">
                  {data.Events.GreencolorDay.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
              </div>
            <br></br>

        <div className='photo-sec'>
            <div className='photo-box'>
              <Link to="../img/Events/color day/Orange/orange-color-day01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Orange/orange-color-day01.webp'></img>
            </Link>
            </div>
            <div className='photo-box'>
              <Link to="../img/Events/color day/Orange/orange-color-day02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Orange/orange-color-day02.webp'></img>
            </Link>
            </div>
            <div className='photo-box'>
              <Link to="../img/Events/color day/Orange/orange-color-day03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Orange/orange-color-day03.webp'></img>
            </Link>
            </div>
            <div className='photo-box'>
              <Link to="../img/Events/color day/Orange/orange-color-day04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Orange/orange-color-day04.webp'></img>
            </Link>
            </div>
            <div className='photo-box'>
              <Link to="../img/Events/color day/Orange/orange-color-day05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Orange/orange-color-day05.webp'></img>
            </Link>
            </div>
            <div className='photo-box'>
              <Link to="../img/Events/color day/Orange/orange-color-day06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Orange/orange-color-day06.webp'></img>
            </Link>
            </div>
          </div>

<div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-01.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-01.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-02.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-02.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-03.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-03.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-04.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-04.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-05.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-05.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-06.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-06.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-07.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-07.jpeg'></img>
            </Link>
            </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/Green2025/img-08.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Green2025/img-08.jpeg'></img>
            </Link>
            </div>
        </div>




        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-1.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-1.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-2.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-2.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-3.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-3.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-4.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-4.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-5.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-5.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-6.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-6.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-7.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-7.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-8.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-8.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-9.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-10.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-11.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-12.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-13.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-14.webp'></img>
            </Link>
          </div>

          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/color day/White/White Color Day-16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/White/White Color Day-16.webp'></img>
            </Link>
          </div>
        </div>
        <br />
        <br />
        <div className='photo-sec'>
          {/* blue color day */}
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-01.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-02.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-03.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-04.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-05.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-06.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-07.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-08.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-09.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-10.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-11.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-12.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-13.webp'></img>
            </Link>
          </div>
            <div className='photo-box'>
            <Link to="../img/Events/color day/Blue/blue-14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/color day/Blue/blue-14.webp'></img>
            </Link>
          </div>

        </div>
        <br />
        <br />
      </div>
    },
     {
      title: 'Recitation Competition ', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'> Inter House Recitation Competition </h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Recitation/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Recitation/img07.webp'></img>
            </Link>
          </div>
         
        </div>
        </div>
        },

        {
      title: 'Origami Competition', content: () => <div>

        <div className='cam-lower-sec'>
          <h1 className='title'>Inter House Origami Competition</h1>
        </div>

        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/orgiamic/img15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/orgiamic/img15.webp'></img>
            </Link>
          </div>
          </div>
          </div>
        },
          {
      title: 'Well Being Workshop', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Well Being Workshop</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/wellbeing/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/wellbeing/img13.webp'></img>
            </Link>
          </div>
          </div>
          </div>
          },
          {
      title: 'Clay Moulding Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Clay Moulding Day</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img16.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img17.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img17.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img18.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img18.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img19.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img19.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img20.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img20.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/clay moulding/img21.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/clay moulding/img21.webp'></img>
            </Link>
          </div>
          </div>
          </div>
          }, 
          {
      title: 'Youth Skill Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Youth Skill Day</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img16.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img17.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img17.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img18.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img18.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img19.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img19.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img20.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img20.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img21.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img21.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img22.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img22.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/youth skill day/img23.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/youth skill day/img23.webp'></img>
            </Link>
          </div>
          </div>
          </div>
        },
    {
      title: 'Annual Prize Distribution', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Annual Prize Distribution</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Annual Prize Distribution/new/APD6-1920x1277.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Annual Prize Distribution/new/APD6-1920x1277.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Annual Prize Distribution/new/APD-1-1920x1277.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Annual Prize Distribution/new/APD-1-1920x1277.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Annual Prize Distribution/new/APD-2-1920x1277.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Annual Prize Distribution/new/APD-2-1920x1277.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Annual Prize Distribution/new/APD-3-1920x1277.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Annual Prize Distribution/new/APD-3-1920x1277.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Annual Prize Distribution/new/APD-5-1920x1277.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Annual Prize Distribution/new/APD-5-1920x1277.jpeg'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Annual Prize Distribution/new/APD4-1920x1277.jpeg"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Annual Prize Distribution/new/APD4-1920x1277.jpeg'></img>
            </Link>
          </div>
        </div>
      </div>
    },
    {
      title: 'Janamashtami Celebration', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Janamashtami 2026</h1>
        </div>
        <div className='photo-sec'>
          <div className="photo-sec">
                  {data.Events.JanamashtamiCelebration.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
                  ))}
              </div>
        </div>
      </div>
    },
    {
      title: 'Adventure Camp', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Adventure Camp</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-1.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-1.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-2.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-2.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-3.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-3.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-4.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-4.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-5.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-5.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-6.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-6.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-7.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-7.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-8.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-8.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-9.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-9.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-16.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-17.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-17.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-18.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-18.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-19.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-19.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-20.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-20.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-21.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-21.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-22.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-22.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-23.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-23.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-24.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-24.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-25.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-25.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-26.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-26.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-27.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-27.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-28.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-28.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-29.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-29.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-30.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-30.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-31.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-31.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-32.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-32.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-33.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-33.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Adventure/M-34.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Adventure/M-34.webp'></img>
            </Link>
          </div>
        </div>
      </div>
    },
    {
      title: 'Earth Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Earth Day</h1>
        </div>
        <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/EarthDay/2026/earth-day-12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/EarthDay/2026/earth-day-12.webp'></img>
            </Link>
          </div>
          </div>
          </div>
    },
    {
      title: 'Math Quiz', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Inter House Math Quiz</h1>
        </div>
          <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/maths/img15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/maths/img15.webp'></img>
            </Link>
          </div>
          </div>
        </div>
    },
    {
      title: 'Republic Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Republic Day 2026</h1>
        </div>
          <div className='photo-sec'>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img01.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img01.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img02.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img02.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img03.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img03.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img04.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img04.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img05.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img05.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img06.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img06.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img07.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img07.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img08.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img08.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img09.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img09.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img10.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img10.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img11.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img11.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img12.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img12.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img13.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img13.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img14.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img14.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img15.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img15.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img16.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img16.webp'></img>
            </Link>
          </div>
          <div className='photo-box'>
            <Link to="../img/Events/Republic Day/2026/img17.webp"
              target="_blank"
              rel="noopener noreferrer">
              <img src='../img/Events/Republic Day/2026/img17.webp'></img>
            </Link>
          </div>
        </div>
        </div>
    },
    {
      title: 'Independence Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Independence Day</h1>
        </div>
        <div className="photo-sec">
                  {data.Events.IndependenceDay.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
              </div>
      </div>
    },
    {
      title: 'Gardening Day', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Gardening Day</h1>
        </div>
        <div className="photo-sec">
                  {data.Events.GardeningDay.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
              </div>
      </div>
    },
     {
      title: 'Raksha Bandhan Celebration', content: () => <div>
        <div className='cam-lower-sec'>
          <h1 className='title'>Raksha Bandhan Celebration</h1>
        </div>
        <div className="photo-sec">
                  {data.Events.RakshaBandhan.map((person) => (
                      <div key={person.id} className="photo-box">
                        <Link 
                          to={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage 
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${person.img}`} 
                            alt={person.alt} 
                          />
                        </Link>
                      </div>
         
                  ))}
              </div>
      </div>
    },
    {
      title: 'Children Day', content: () => <div>
          <div className='cam-lower-sec'>
          <h1 className='title'>Children's Day 2025</h1>
        </div>
         <div className='photo-sec'>
          {data.Events.chday.map((person) => (
            <div key={person.id} className="photo-box">
              <Link to={person.img} target="_blank"
                rel="noopener noreferrer">
                <LazyLoadImage src={person.img} alt={person.alt} />
              </Link>
            </div>
          ))}
        </div>
      </div>
    }
  ]
  // 👉 yahan se active tab track karenge
  const tabs = [...dynamicTabs, ...staticTabs];
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const activeHeroImg = tabs[activeTabIndex]?.heroImg;
  const activeHeroAlt = tabs[activeTabIndex]?.title;
   return (
    <div>
      {/* HERO IMAGE AB DYNAMIC HAI */}
      <div className='ibdp-hero-sec'>
        {activeHeroImg && (
          <img src={activeHeroImg} alt={activeHeroAlt} />
        )}
      </div>
      <div className="newsletter-sec">
        <HorizontalTabs
          tabs={tabs}
          activeTabIndex={activeTabIndex}       // 👈 ab control yahan se
          onTabChange={setActiveTabIndex}      // 👈 jab tab click ho
        />
      </div>
    </div>
  );
}
export default Events
